// extracted by mini-css-extract-plugin
module.exports = {"main":"DeviceSettingCheckBox_main__387Pv"};